import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UtilsService } from 'src/app/shared/utils.service';
import { AccountsSelectorComponent } from 'src/app/admin/accounts/accounts-selector/accounts-selector.component';

@Component({
    selector: 'app-codes-filter',
    templateUrl: './codes-filter.component.html',
    styleUrls: ['./codes-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CodesFilterComponent implements OnInit {

  // Codes search filters.
  filters: {
    search_by: string,
    only_archived: string,
    feature: string,
    type: string,
    selected_accounts: any[]
  } = {
    search_by: 'id',
    only_archived: 'false',
    feature: '',
    type: '',
    selected_accounts: []
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CodesFilterComponent>,
    public utils: UtilsService
  ) {
    // Set a default searchBy value of 'id' if no values are passed through.
    if (typeof this.data['search_by'] == 'undefined') {
      this.data['search_by'] = 'id';
    }

    // Set a default only_archived value of false if no values are passed through.
    if (typeof this.data['only_archived'] == 'undefined') {
      this.data['only_archived'] = false;
    }

    // Default the feature and type filters to "any" (empty) when not provided.
    if (typeof this.data['feature'] == 'undefined') {
      this.data['feature'] = '';
    }
    if (typeof this.data['type'] == 'undefined') {
      this.data['type'] = '';
    }

    // Default the account filter to an empty selection when not provided.
    if (!Array.isArray(this.data['selected_accounts'])) {
      this.data['selected_accounts'] = [];
    }
  }

  ngOnInit() {
    // Apply the new inbound searchBy filter.
    this.filters.search_by = this.data['search_by'];
    this.filters.only_archived = this.data['only_archived'];
    this.filters.feature = this.data['feature'];
    this.filters.type = this.data['type'];
    this.filters.selected_accounts = [...this.data['selected_accounts']];
  }

  /**
   * The comma-separated names of the selected accounts, for display.
   */
  get selectedAccountNames(): string {
    return this.filters.selected_accounts.map((account) => account?.name).filter((name) => !!name).join(', ');
  }

  /**
   * Open the admin accounts selector to choose which accounts to filter by. It returns
   * the full account objects (returnObjects) so the selected names can be displayed.
   */
  onSelectAccounts() {
    this.utils.showComponentDialog(
      AccountsSelectorComponent,
      { selected: this.filters.selected_accounts, multiple: true, returnObjects: true },
      { width: '900px' },
      (accounts) => {
        if (Array.isArray(accounts)) {
          this.filters.selected_accounts = accounts;
        }
      }
    );
  }

  /**
   * Clear the selected account filter.
   */
  onClearAccounts() {
    this.filters.selected_accounts = [];
  }

  /**
   * Used to clear the search filters.
   */
  onClearAndClose() {
    // Reset search_by to 'id' and only_archived to false.
    this.filters.search_by = 'id';
    this.filters.only_archived = 'false';
    this.filters.feature = '';
    this.filters.type = '';
    this.filters.selected_accounts = [];
    // Save and close the dialog.
    this.onSaveAndClose();
  }

  /**
   * Used to send the filters back to the calling component.
   */
  onSaveAndClose() {
    this.dialogRef.close(this.filters);
  }
}
